import DVCApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';
class DVCFileC402API extends DVCApi {
  constructor() {
    super();
  }
  controllerName = 'DVCFileC402s';
}
export default new DVCFileC402API();
